module.exports = __webpack_public_path__ + "static/about-investition3-697a53a540a107b927d5f090e441171f.jpg";